import QuoteIllustration from '../components/illustrations/QuoteIllustration.jsx';
import ProjectsIllustration from '../components/illustrations/ProjectsIllustration.jsx';
import InvoicesIllustration from '../components/illustrations/InvoicesIllustration.jsx';
import CashIllustration from '../components/illustrations/CashIllustration.jsx';

/**
 * The four things Revetall does, in the order a job runs: quote, project, invoice, cash.
 * Each gets a card on the front page and its own page at `path`.
 * Texts live under `features.<id>` in the translations. Next to the steps the feature page
 * shows a chat (`features.<id>.chat`), a warning email (`features.<id>.email`, when `demo` is
 * 'email') or a screen from the app (`features.<id>.app`, when `demo` is 'app').
 */
export const FEATURES = [
  { id: 'erfaringstall', path: '/erfaringstall', Illustration: QuoteIllustration },
  { id: 'prosjekter', path: '/prosjekter', Illustration: ProjectsIllustration, demo: 'email' },
  { id: 'fakturaer', path: '/fakturaer', Illustration: InvoicesIllustration, demo: 'app' },
  { id: 'likviditet', path: '/likviditet', Illustration: CashIllustration, demo: 'email' },
];
